import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import {
  fadeInChild,
  fadeLeftChild,
  fadeRightChild,
  fadeUpChild,
  animatedParent,
} from './variants';

export const AnimateChild = ({ children, direction }) => {
  switch (direction) {
    case 'up':
      return <motion.div variants={fadeUpChild}>{children}</motion.div>;
    case 'left':
      return <motion.div variants={fadeLeftChild}>{children}</motion.div>;
    case 'right':
      return <motion.div variants={fadeRightChild}>{children}</motion.div>;
    case 'in':
      return <motion.div variants={fadeInChild}>{children}</motion.div>;
    default:
      return <motion.div variants={fadeUpChild}>{children}</motion.div>;
  }
};

export const AnimateParent = ({ children }) => {
  const [ref, inView] = useInView({
    rootMargin: '-100px 0px',
    triggerOnce: true,
  });

  return (
    <motion.div
      ref={ref}
      variants={animatedParent}
      initial="initial"
      animate={inView ? 'enter' : 'initial'}
      exit="initial">
      <main>{children}</main>
    </motion.div>
  );
};
